import b from 'b_';
import { H3 } from 'platform-components';
import { HEADER_TEXT_SIZE, TEXT_WEIGHT } from 'platform-components/src/components/constants';
import React from 'react';

import './calendar-plan-showcase__lesson-theme-name.scss';

interface Props {
    name: string;
    size?: HEADER_TEXT_SIZE;
}

export const CalendarPlanShowcaseLessonThemeName = ({ name, size = HEADER_TEXT_SIZE.M }: Props) => (
    <div className={b('calendar-plan-showcase', 'lesson-theme-name')}>
        <H3 ellipsis fixed size={size} weight={TEXT_WEIGHT.M}>
            {name}
        </H3>
    </div>
);
